import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const PreviewContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 200px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.primaryExtraLight};
`

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
  border-radius: 4px;
`

// Row of action buttons pinned to the top-right of the preview.
export const ActionsRow = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  display: flex;
  gap: 6px;
`

// Semi-transparent while an image is underneath (Enhance/Resize in flight, or a
// new avatar decoding over the previous one) so the current source stays dimly
// visible behind the spinner — same rgba-white convention as DotsLoading /
// LoadingGradient. Solid otherwise (nothing to show through yet).
export const LoadingOverlay = styled.div<{ $hasImage?: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $hasImage }) =>
    $hasImage ? 'rgba(0, 0, 0, 0.4)' : COLORS.primaryExtraLight};
`
